// Contrail V3.7.0 — devices + live device_state over Realtime, shared hook (used by the mobile app).
// V3.12.0: the subscription is kept healthy by useLiveFeed (reloads on resume / reconnect, polls while down).
import { useCallback, useEffect, useState } from "react";
import { supabase, type Device, type DeviceState } from "./supabase";
import { useLiveFeed, type FeedState } from "./liveFeed";

export function useLiveDevices() {
  const [devices, setDevices] = useState<Device[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [now, setNow] = useState(Date.now());

  const load = useCallback(async () => {
    const { data, error } = await supabase
      .from("devices")
      .select("id, org_id, name, model, unique_id, status, icon, icon_color, tail_on, tail_minutes, tail_seconds, tail_color, group_id, device_state(*)")
      .order("name");
    if (error) { setError(error.message); setLoaded(true); return; }
    setError(null);
    setDevices((data ?? []).map((d: any) => ({ ...d, state: Array.isArray(d.device_state) ? d.device_state[0] ?? null : d.device_state ?? null })));
    setLoaded(true);
    setNow(Date.now());
  }, []);
  useEffect(() => { load(); }, [load]);

  const onRow = useCallback((s: DeviceState) => {
    if (!s?.device_id) return;
    setDevices((prev) => prev.map((d) => (d.id === s.device_id ? { ...d, state: s } : d)));
  }, []);
  const feed: FeedState = useLiveFeed("m_device_state_live", "device_state", onRow, load);

  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 15000); return () => clearInterval(t); }, []);

  return { devices, loaded, error, live: feed === "live", feed, now };
}
